// extracted by mini-css-extract-plugin
export default {"modal":"modal__Yrtn2","modalPopup":"modalPopup__C2hgm","spinner":"spinner__aBX2t"};